"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _desktopLgRegular = _interopRequireDefault(require("./images/desktop-lg-regular.svg"));
var _desktopLgDanger = _interopRequireDefault(require("./images/desktop-lg-danger.svg"));
var _desktopMdRegular = _interopRequireDefault(require("./images/desktop-md-regular.svg"));
var _desktopMdDanger = _interopRequireDefault(require("./images/desktop-md-danger.svg"));
var _desktopSmRegular = _interopRequireDefault(require("./images/desktop-sm-regular.svg"));
var _desktopSmDanger = _interopRequireDefault(require("./images/desktop-sm-danger.svg"));
var _tabletLgRegular = _interopRequireDefault(require("./images/tablet-lg-regular.svg"));
var _tabletLgDanger = _interopRequireDefault(require("./images/tablet-lg-danger.svg"));
var _tabletMdRegular = _interopRequireDefault(require("./images/tablet-md-regular.svg"));
var _tabletMdDanger = _interopRequireDefault(require("./images/tablet-md-danger.svg"));
var _tabletSmRegular = _interopRequireDefault(require("./images/tablet-sm-regular.svg"));
var _tabletSmDanger = _interopRequireDefault(require("./images/tablet-sm-danger.svg"));
var _mobileLgRegular = _interopRequireDefault(require("./images/mobile-lg-regular.svg"));
var _mobileLgDanger = _interopRequireDefault(require("./images/mobile-lg-danger.svg"));
var _mobileMdRegular = _interopRequireDefault(require("./images/mobile-md-regular.svg"));
var _mobileMdDanger = _interopRequireDefault(require("./images/mobile-md-danger.svg"));
var _mobileSmRegular = _interopRequireDefault(require("./images/mobile-sm-regular.svg"));
var _mobileSmDanger = _interopRequireDefault(require("./images/mobile-sm-danger.svg"));
var ICON_SRC_MAPPER = {
  desktop: {
    lg: {
      regular: _desktopLgRegular["default"],
      danger: _desktopLgDanger["default"]
    },
    md: {
      regular: _desktopMdRegular["default"],
      danger: _desktopMdDanger["default"]
    },
    sm: {
      regular: _desktopSmRegular["default"],
      danger: _desktopSmDanger["default"]
    }
  },
  tablet: {
    lg: {
      regular: _tabletLgRegular["default"],
      danger: _tabletLgDanger["default"]
    },
    md: {
      regular: _tabletMdRegular["default"],
      danger: _tabletMdDanger["default"]
    },
    sm: {
      regular: _tabletSmRegular["default"],
      danger: _tabletSmDanger["default"]
    }
  },
  mobile: {
    lg: {
      regular: _mobileLgRegular["default"],
      danger: _mobileLgDanger["default"]
    },
    md: {
      regular: _mobileMdRegular["default"],
      danger: _mobileMdDanger["default"]
    },
    sm: {
      regular: _mobileSmRegular["default"],
      danger: _mobileSmDanger["default"]
    }
  }
};
var BREAKPOINT_SM = 24;
var BREAKPOINT_MD = 60;
var DeviceIcon = exports.DeviceIcon = function DeviceIcon(props) {
  var isDanger = props.isDanger,
    className = props.className,
    device = props.device,
    _props$size = props.size,
    size = _props$size === void 0 ? 100 : _props$size;
  var deviceType = 'desktop';
  switch (device) {
    case 'iPhone':
      deviceType = 'mobile';
      break;
    case 'iPad':
      deviceType = 'tablet';
  }
  var sizeType = size < BREAKPOINT_SM ? 'sm' : size < BREAKPOINT_MD ? 'md' : 'lg';
  var state = isDanger ? 'danger' : 'regular';
  return /*#__PURE__*/_react["default"].createElement("img", {
    className: className,
    src: ICON_SRC_MAPPER[deviceType][sizeType][state],
    width: size,
    alt: ""
  });
};